import React, { useState, useEffect } from "react";
import { default as ReactSelect } from "react-select";
import { components } from "react-select";
import { Box, Flex, Text } from "@chakra-ui/react";

const MultiSelectPermissionBox = ({
  IdData,
  selectedPermissions,
  setSelectedPermissions,
  groupData,
  activeColor,
}) => {
  const [selectAllChecked, setSelectAllChecked] = useState(false);

  useEffect(() => {
    if (selectedPermissions.length === IdData.length) {
      setSelectAllChecked(true);
    } else {
      setSelectAllChecked(false);
    }
  }, [selectedPermissions.length, IdData.length]);

  const handleAllChecked = (id) => (event) => {
    const idArray = [];
    const myData = IdData.filter((f) => f.permission_group_id === id);
    if (event.target.checked) {
      for (let i = 0; i < myData.length; i++) {
        idArray.push({
          id: myData[i].id,
          name: myData[i].name,
          permission_group_id: myData[i].permission_group_id,
        });
      }
      setSelectedPermissions(selectedPermissions.concat(idArray));
    } else {
      setSelectedPermissions((current) =>
        current.filter((element) => {
          return element.permission_group_id !== id;
        })
      );
    }
  };

  const handleCheckChildElement = (data) => (event) => {
    const idArray = [];
    if (event.target.checked) {
      idArray.push({
        id: data.id,
        name: data.name,
        permission_group_id: data.permission_group_id,
      });
      setSelectedPermissions(selectedPermissions.concat(idArray));
    } else {
      setSelectedPermissions((current) =>
        current.filter((element) => {
          return element.id !== data.id;
        })
      );
    }
  };

  const handleGroupChecked = (id) => {
    return selectedPermissions.some(function (el) {
      return el.permission_group_id === id;
    });
  };

  const handleOptionChecked = (id) => {
    return selectedPermissions.some(function (el) {
      return el.id === id;
    });
  };

  const handleSelectAll = (event) => {
    const idArray = [];
    if (event.target.checked) {
      for (let i = 0; i < IdData.length; i++) {
        idArray.push({
          id: IdData[i].id,
          name: IdData[i].name,
          permission_group_id: IdData[i].permission_group_id,
        });
      }
      setSelectedPermissions(selectedPermissions.concat(idArray));
    } else {
      setSelectedPermissions([]);
    }
  };

  const MultiValue = (props) => {
    let labelToBeDisplayed = `${props.data.name}, `;
    return (
      <components.MultiValue {...props}>
        <span>{labelToBeDisplayed}</span>
      </components.MultiValue>
    );
  };

  const customStyles = {
    control: (styles) => ({
      ...styles,
      height: "3rem",
      borderColor: "#DCE3EB !important",
    }),
    placeholder: (styles) => {
      return {
        ...styles,
        color: "#9AA6CF",
        fontSize: "17px",
        paddingLeft: "5px",
      };
    },
    option: (styles, { isFocused, isSelected }) => ({
      ...styles,
      color: "black",
      background: isFocused ? "white" : isSelected ? "white" : "white",
      zIndex: 1,
    }),
    valueContainer: (styles) => {
      return {
        ...styles,
        maxHeight: "30px",
      };
    },
    multiValueRemove: (base) => ({ ...base, display: "none" }),
  };

  const Option = (props) => {
    return (
      <Box>
        {props.innerProps.id.includes("option-0") ? (
          <div>
            <components.Option {...props}>
              <div>
                <Flex alignItems="center">
                  <input
                    type="checkbox"
                    onChange={handleSelectAll}
                    value={"select all"}
                    checked={selectAllChecked}
                  />{" "}
                  <Text pl="5px" fontWeight="bold">
                    Select All
                  </Text>
                </Flex>
                {groupData.map((item, index) => (
                  <div key={index.id}>
                    {item.permissions.length > 0 ? (
                      <Flex alignItems="center">
                        <input
                          type="checkbox"
                          onChange={handleAllChecked(item.group_id)}
                          value={item.group_id}
                          checked={handleGroupChecked(item.group_id)}
                        />{" "}
                        <Text pl="5px" fontWeight="bold">
                          {item.group_name}
                        </Text>
                      </Flex>
                    ) : null}
                    <ul style={{ paddingLeft: "20px", listStyle: "none" }}>
                      {IdData.filter(
                        (data) => data.permission_group_id === item.group_id
                      ).map((dat, findex) => {
                        return (
                          <li key={dat.id}>
                            <input
                              onChange={handleCheckChildElement(dat)}
                              type="checkbox"
                              checked={handleOptionChecked(dat.id)}
                              value={`${dat.id}`}
                            />{" "}
                            {dat.name}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                ))}
              </div>
            </components.Option>
          </div>
        ) : null}
      </Box>
    );
  };
  return (
    <ReactSelect
      options={IdData}
      isMulti
      closeMenuOnSelect={false}
      hideSelectedOptions={false}
      isClearable={false}
      components={{
        Option,
        MultiValue,
      }}
      styles={customStyles}
      allowSelectAll={true}
      value={selectedPermissions}
    />
  );
};

export default MultiSelectPermissionBox;
